<template>
<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" style="" xml:space="preserve" width="44.741573333740234" height="51.617977142333984"><rect id="backgroundrect" width="100%" height="100%" x="0" y="0" fill="none" stroke="none" class="" style=""/>



<g class="currentLayer" style=""><title>Layer 1</title><path class="st0" d="M42.19437885284424,48.64719552993773 v-16.7 c-0.1,-4 -3.7,-7.3 -9,-7.3 h-0.3000000000000001 h-3.5 l-4,5 l-3.7,-4.7 l-3.8,-0.3000000000000001 l-6.8,-7.7 l0.1,-11.4 c0,-1.8 -1.4,-3.3 -3.2,-3.3 s-3.3,1.4 -3.3,3.2 l-0.2,13.6 c0,0.6000000000000002 0.2,1.1 0.4,1.5 c0.1,0.3000000000000001 0.3000000000000001,0.6000000000000002 0.5,0.9 l10.8,12.3 v14.9 h17.8 v-15.8 h0.3000000000000001 v0.1 v15.7 L42.19437885284424,48.64719552993773 z" id="svg_1"/><circle class="st0" cx="25.894375801086426" cy="12.84719705581665" r="7.599999904632568" id="svg_2"/></g></svg>
</template>

<script>
export default {
    name: 'IconP6',
}
</script>

<style lang="scss" scoped>
    .st0{fill:none;stroke:$grey-light;stroke-width:2;stroke-miterlimit:10;}
</style>